// @ts-nocheck
import styled from '@emotion/styled';

import { colors, fonts } from '../../styles';

interface BodyTextProps {
  color?: string;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const BodyText = styled('div')<BodyTextProps>`
  color: ${(props) => props.color || colors.black};
  font-size: ${fonts.size.small};
  font-weight: ${fonts.weight.light};
  line-height: 1.36;
`;
